export function validateProp(valueDefinitions, value) {
    return Object.keys(valueDefinitions)
        .map((key) => valueDefinitions[key])
        .includes(value);
}

export function getSearch(refs) {
    let search = {};
    let anyFail;
    for (let ref in refs) {
        let element = refs[ref][0];
        if (element.name.startsWith('search.')) {
            let elementValue = element.modelValue;

            if (!element.validateInput(elementValue)) {
                return null;
            }
            let validInput = element.validateInput(elementValue);
            if (validInput) {
                const name = element.name.substring(
                    element.name.indexOf('.') + 1
                );
                search[name] = elementValue;
            }
        }
    }
    return search;
}
